import { useRefreshOrders } from '@src/orders/hooks/useRefreshOrders';
import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useMutation } from '@tanstack/react-query';

export const useAddPermits = ({
  orderId,
  onSuccess,
}: {
  orderId: string;
  onSuccess: () => void;
}) => {
  const { refreshOrders } = useRefreshOrders();

  const { mutate, isPending } = useMutation({
    mutationFn: (data: {
      permits: { quantity: number; typeId: string; typeOriginalId: string }[];
    }) => OrdersClient.addPermits(orderId, data),
    onSuccess: () => {
      onSuccess();
      refreshOrders();
    },
  });

  return {
    addPermits: mutate,
    isLoading: isPending,
  };
};
